import React, {Component, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import socketService from '../../services/socket';

const styles = {
  wrap: {
    position: 'fixed',
    bottom: 5,
    left: 5,
    zIndex: 9999,
    background: '#00a0e3',
    color: '#ffffff',
    fontWeight: 'bold',
    borderRadius: 10,
    padding: 5,
    opacity: 0.6,
  },
  icon: {
    display: 'inline-block',
    width: 10,
    height: 10,
    borderRadius: 25,
    background: '#ffffff',
    marginRight: 7,
  },
};

class SlowConnection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
    this.initTimeout = null;
    this.requestTimeout = null;
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.sendRequest();
    }, 1500);
  }

  componentWillUnmount() {
    if (this.initTimeout) {
      clearTimeout(this.initTimeout);
    }

    if (this.requestTimeout) {
      clearTimeout(this.requestTimeout);
    }
  }

  sendRequest = () => {
    const socket = socketService.getSocket('backendS');

    this.requestTimeout = setTimeout(() => {
      if (!this.state.visible) {
        this.setState({visible: true});
      }
    }, 1000);

    socket.emit('connection-test');
    socket.on('connection-test-answer', () => {
      clearTimeout(this.requestTimeout);
      if (this.state.visible) {
        this.setState({visible: false});
      }
    });

    return setTimeout(this.sendRequest, 5000);
  };

  render() {
    const {visible} = this.state;
    if (!visible) {
      return null;
    }
    return (
      <div style={styles.wrap}>
        <div style={styles.icon} />
        <span>Низкий уровень соединения</span>
      </div>
    );
  }
}

export default SlowConnection;
